import Flickity from 'flickity';
import modals from '../modal'
import $, { ajax, timers } from 'jquery';
import {
  cleanNumberRegex,
  emailRegex,
  phoneRegex,
  currencyFormat,
  currencyDecimalFormat,
  formatCalculatorValue,

} from './utils'
import UTMTracking from "../tracking";

export default (function () {
  'use strict';
  var forms = document.querySelector('.multiform-wrap');
  var adjusts = document.querySelector('.form-adjustments');

  let currentXhr = [];

  function initMultiStepForm() {

    class FormWizard {
      constructor(prop_element = null) {

        this.urlParams = new URLSearchParams(window.location.search);

        this.element = prop_element
        this.stepUriIndex = {}
        this.steps = [...this.element.querySelectorAll('.js-tab')]
        this.formControls = [...this.element.querySelectorAll('.js-form-control')]
        this.btnPrev = this.element.querySelector('.js-btn-prev')
        this.btnNext = this.element.querySelector('.js-btn-next')
        this.progressBar = this.element.querySelector('.js-progress-bar span')

        this.defaultValues = {
          purchasePrice: '400000',
          propertyValue: '400000',
          currentMortgage: '100000',
          requestedLineAmount: '250000',
        }

        // Map step uris to their numeric index
        this.steps.forEach((step, index) => {
          this.stepUriIndex[step.dataset.step] = index
        })

        // Force the last possible step to be the quote
        this.stepUriIndex['quote'] = this.steps.length

        // Default the current index to zero
        this.currentStepIdx = 0

        this.handleConditionalCheck = this.handleConditionalCheck.bind(this)
        this.placesAutocompleteInputHandler = this.placesAutocompleteInputHandler.bind(this)
        this.handleIncrementClick = this.handleIncrementClick.bind(this)
        this.handleMoneyBlur = this.handleMoneyBlur.bind(this)
        this.handleDownPaymentConnectChange = this.handleDownPaymentConnectChange.bind(this)
        this.handleStoreFieldInput = this.handleStoreFieldInput.bind(this)

        this.whichForm = document.querySelector('.free-rate-quote')

        this.init()
      }

      init() {
        this.setDefaults()
        this.format()
        this.store()
        this.showStepFromUrl()
        this.addEvents()
      }

      saveValue(element) {
        var values = JSON.parse(localStorage.getItem('js-form-control') || '{}');

        // Update the connected element as you slide
        if (element.dataset.target) {
          let targetElement = document.getElementById(element.dataset.target)
          if (targetElement) {
            let targetFormat = targetElement.dataset.format
            targetElement.value = targetFormat ? formatCalculatorValue(element.value, targetFormat) : element.value
          }
        }

        if (element.type === 'checkbox') {
          values[element.name] = this.getCheckboxValue(element)
        } else if (!element.classList.contains('js-money')) {
          values[element.name] = element.value;
        } else {
          values[element.name] = element.value.replace(cleanNumberRegex, '');
        }

        localStorage.setItem('js-form-control', JSON.stringify(values));
      }

      handleStoreFieldInput(event) {
        let element = event.target
        this.saveValue(element)
      }

      setDefaults() {
        var values = JSON.parse(localStorage.getItem('js-form-control') || '{}');

        values = { ...this.defaultValues, ...values, }
        localStorage.setItem('js-form-control', JSON.stringify(values))
      }

      store() {
        var values = JSON.parse(localStorage.getItem('js-form-control') || '{}');
        var inputs = [...document.querySelectorAll('.js-form-control')];

        inputs.forEach((element, index) => {

          if (element.type != 'checkbox') {
            element.value = values[element.name] || ''; // stored value if it exists or empty string
          }

          if (element.type === 'checkbox') {
            // attempt to update any conditional steps if there are any for this checkbox
            element.checked = values[element.name] && values[element.name].length
            this.updateConditionalFromCheckboxState(element)
          }

          let format = element.dataset.format
          if (format) {
            let formattedValue = formatCalculatorValue(element.value, format)
            element.value = formattedValue
          }

          element.removeEventListener('input', this.handleStoreFieldInput);
          element.addEventListener('input', this.handleStoreFieldInput);
        });
      }

      format() {
        var inputs = document.querySelectorAll('input[type="text"]');

        inputs.forEach(function(input) {
          input.addEventListener('blur', function(event) {

            const target = event.target

            let format = target.dataset.format
            if (!format) {
              return;
            }

            let formattedValue = formatCalculatorValue(target.value, format)
            target.value = formattedValue
          });

          // On focus, switch to using just numeric value
          input.addEventListener('focus', (event) => {
            let format = event.target.dataset.format
            if (!format) {
              return;
            }
            event.target.value = event.target.value.replace(cleanNumberRegex, '')
          })
        });
      }

      getCheckboxValue(checkbox) {
        return checkbox && checkbox.checked && checkbox.value || ''
      }

      getStepIndexFromUri(uri) {
        return this.stepUriIndex[uri] || 0
      }

      getStepUriFromIndex(index) {
        const stepUris = Object.keys(this.stepUriIndex)
        return stepUris.find((uri) => this.stepUriIndex[uri] === index)
      }

      showStepFromUrl() {
        const stepUri = this.urlParams.get('step')
        const stepIndex = this.getStepIndexFromUri(stepUri)

        // Reset the scroll position for each step
        window.scrollTo(0, 0)

        if (stepUri == 'quote' && this.urlParams.get('quote')) {
          return showQuote(undefined, { urlParams: this.urlParams })
        }

        this.showStep(stepIndex)
      }

      setupDownPaymentConnects() {

        const currentStep = this.steps[this.currentStepIdx]

        var purchasePrice = document.querySelector('.purchase-price-field');
        var moneyValue = currentStep.querySelector('.d-payment');

        if (!moneyValue) {
          return;
        }

        var percentageValue = currentStep.querySelector('.d-payment-percentage');
        var rangeSlider = currentStep.querySelector('.range-slider')
        var connects = currentStep.querySelectorAll('.connected');

        // Update the range for the downpayment to relate to the purchase price
        rangeSlider.setAttribute('min', 0)

        const maxValue = purchasePrice.value.replace(cleanNumberRegex, '').replace(/\.\d+$/, '');

        rangeSlider.setAttribute('max', maxValue)

        const maxLabel = document.getElementById('amount-down-max')
        if (maxValue.length === 6) {
          maxLabel.textContent = `$${maxValue.substring(0, 3)}K`
        } else if (maxValue.length === 7) {
          maxValue.substring(0, 4) / 1000
          maxLabel.textContent = `$${(maxValue.substring(0, 4) / 1000).toFixed(2).replace(/\.00$/, '')}M`
        }

        if (connects) {
          connects.forEach((connect) => {
            connect.removeEventListener('change', this.handleDownPaymentConnectChange)
            connect.addEventListener('change', this.handleDownPaymentConnectChange)
          });

          const downPaymentValue = moneyValue.value.replace(cleanNumberRegex, '')
          if (!localStorage.getItem('downPaymentUpdated') && downPaymentValue == 0) {
            rangeSlider.value = parseFloat(purchasePrice.value.replace(cleanNumberRegex, '')) * .2
          }

          // Trigger a change on the range slider incase the purchase price changed
          rangeSlider.dispatchEvent(new Event('change'))
        }

      }

      showStep(prop_stepIdx = 0) {

        if (currentXhr && currentXhr.length) {
          currentXhr.forEach((xhr) => xhr.abort())
          currentXhr = [];
        }

        // Remove the currently active step
        let activeStep = this.steps.find((step) => step.classList.contains('is-active'))
        if (activeStep) {
          activeStep.classList.remove('is-active')
        }

        const stepIdx = prop_stepIdx

        if (stepIdx >= this.steps.length) {
          console.log('localStorage data is:')
          console.log(JSON.parse(localStorage.getItem('js-form-control')));

          const postData = getRequestData(this.whichForm.name)
          showQuote(postData, { urlParams: this.urlParams })
          return;
        }

        const currentStep = this.steps[stepIdx]

        this.currentStepIdx = stepIdx

        localStorage.setItem('step-index', stepIdx);
        currentStep.classList.add('is-active')

        // Update button text
        this.btnPrev.classList[stepIdx === 0 ? 'remove' : 'add']('is-active')
        this.btnNext.innerText = this.btnNext.dataset[stepIdx === this.steps.length - 1 ? 'finalStepText' : 'stepText']

        // Check if the current step needs places autocomplete
        if (currentStep.classList.contains('js-places-autocomplete')) {
          this.setupPlacesAutocomplete(currentStep)
        }

        this.updateProgressBar(stepIdx)

        if (currentStep && currentStep.classList.contains('conditional')) {
          var checkBox = currentStep.querySelector('.conditional-check')

          // attempt to remove the existing event listener incase the user has been here before
          checkBox.removeEventListener('click', this.handleConditionalCheck)
          checkBox.addEventListener('click', this.handleConditionalCheck)
        }

        // handling name change in second slide
        if (this.currentStepIdx === 1) {

          var list = JSON.parse(localStorage.getItem('js-form-control'));
          let firstName = list.firstName
          var formNames = document.querySelectorAll('.js-form-name-input');
          formNames.forEach((formName) => {
            formName.innerHTML = firstName;
          })
          if (window.innerWidth < 768) {
            document.querySelector('.banner').classList.add('reverse')
            document.querySelector('.multiform-wrap').classList.add('reverse')
          }
        } else {
          document.querySelector('.banner').classList.remove('reverse')
          document.querySelector('.multiform-wrap').classList.remove('reverse')
        }

        if (currentStep.classList.contains('increment')) {
          currentStep.querySelectorAll('.plus-minus--button').forEach((button) => {
            button.removeEventListener('click', this.handleIncrementClick)
            button.addEventListener('click', this.handleIncrementClick)
          })
        }

        if (currentStep.classList.contains('money')) {
          currentStep.querySelectorAll('.js-money-format').forEach((money) => {
            money.removeEventListener('blur', this.handleMoneyBlur)
            money.addEventListener('blur', this.handleMoneyBlur)
          })
        }



        if (this.whichForm.name == "quote_looking_to_do_purchase") {
          this.setupDownPaymentConnects()
        }

        if (currentStep.classList.contains('nice-to-meet')) {
          var list = JSON.parse(localStorage.getItem('js-form-control'));
          var dynamics = document.querySelectorAll('.dyn');
          dynamics.forEach((dynamic) => {
            var price = parseInt(Math.ceil((0.01 * list.purchasePrice)));
            var pricePretty = price.toLocaleString("en-US");
            dynamic.innerHTML = '$' + pricePretty;
          })
        }
      }

      updateConditionalFromCheckboxState(checkbox) {
        var conditional = checkbox.closest('.tab')
        var targetStepId = conditional.dataset.target

        if (conditional.hasAttribute('data-target-yes') && conditional.hasAttribute('data-target-no')) {
          var targetYesStepId = conditional.dataset.targetYes
          var targetNoStepId = conditional.dataset.targetNo

          var targetYesStep = document.getElementById(targetYesStepId)
          var targetNoStep = document.getElementById(targetNoStepId)

          if (checkbox.checked) {
            targetYesStep.classList.remove('step-disabled')
            targetNoStep.classList.add('step-disabled')
          } else {
            targetYesStep.classList.add('step-disabled')
            targetNoStep.classList.remove('step-disabled')
          }

          return;
        }

        if (!targetStepId) {
          return;
        }

        var targetStep = document.getElementById(targetStepId)

        if (checkbox.checked) {
          targetStep.classList.remove('step-disabled')
        } else {
          targetStep.classList.add('step-disabled')
        }
      }

      handleConditionalCheck(event) {
        this.updateConditionalFromCheckboxState(event.target)
      }

      handleDownPaymentConnectChange(event) {

        localStorage.setItem('downPaymentUpdated', true)

        const currentStep = this.steps[this.currentStepIdx]

        var purchasePrice = document.querySelector('.purchase-price-field');
        var moneyValue = document.querySelector('.d-payment');
        var percentageValue = document.querySelector('.d-payment-percentage');
        var rangeSlider = currentStep.querySelector('.range-slider');

        const connect = event.target

        var mortgagePrice = parseFloat(purchasePrice.value.replace(cleanNumberRegex, ''));
        var downPayment = parseFloat(moneyValue.value.replace(cleanNumberRegex, ''));

        if (connect.classList.contains('d-payment-percentage')) {
          const percentageDollars = (parseFloat(percentageValue.value.replace(cleanNumberRegex, '')) * mortgagePrice) / 100;

          moneyValue.value = currencyDecimalFormat.format(percentageDollars);
          this.saveValue(moneyValue)

          rangeSlider.value = percentageDollars
          this.saveValue(rangeSlider)

        } else if (connect.classList.contains('d-payment')) {
          percentageValue.value = `${((downPayment / mortgagePrice) * 100).toFixed(1)}%`;
          this.saveValue(percentageValue)

          rangeSlider.value = downPayment
          this.saveValue(rangeSlider)
        } else if (connect.classList.contains('d-payment-range')) {

          const rangeValue = rangeSlider.value.replace(cleanNumberRegex, '');

          moneyValue.value = currencyDecimalFormat.format(rangeValue);
          this.saveValue(moneyValue)

          percentageValue.value = `${(rangeValue / mortgagePrice * 100).toFixed(1)}%`;
          this.saveValue(percentageValue)
        }
      }

      findNextStepIndex() {
        let nextStepIndex = this.steps.findIndex((step, index) => {
          return index > this.currentStepIdx && !step.classList.contains('step-disabled')
        })

        // Purposfully can return above the last index of the array.
        // It's how we determine if the form should be submitted
        return nextStepIndex === -1 && this.steps.length || nextStepIndex
      }

      findPrevStepIndex() {
        // going back, find the closest previous step that's not disabled
        let prevStepIdx = this.currentStepIdx - 1
        while(true) {
          if (this.steps[prevStepIdx] && this.steps[prevStepIdx].classList.contains('step-disabled')) {
            prevStepIdx -= 1;
            continue;
          }

          break;
        }

        return prevStepIdx
      }

      handleIncrementClick(event) {
        const button = event.target
        const targetFieldId = button.dataset.target
        const targetField = document.getElementById(targetFieldId)

        if (!targetField) {
          return;
        }

        const relatedTargetFields = document.querySelectorAll(`[type=range][data-target=${targetField.id}]`)

        let value = parseInt(targetField.value.replace(cleanNumberRegex, ''), 10);
        value = isNaN(value) ? 0 : value;

        if (button.classList.contains('plus')) {
          value += 10000;
        } else if (button.classList.contains('minus') && value > 999) {
          value -= 10000;
        }

        targetField.value = formatCalculatorValue(value, targetField.dataset.format)
        targetField.dispatchEvent(new Event('input'))

        relatedTargetFields.forEach((relatedField) => {
          relatedField.value = value
        })
      }

      handleMoneyBlur(event) {
        if (event.which >= 37 && event.which <= 40) return;
        this.value = currencyDecimalFormat.format(event.target.value.replace(cleanNumberRegex, ''))
      }

      goToPrevNextStep(direction) {

        // direction: 1 == next. 0 == previous
        let goToStepIndex = direction === 1 && this.findNextStepIndex() || this.findPrevStepIndex()

        if (goToStepIndex < 0) {
          history.back()
          return;
        }

        this.urlParams.set('step', this.getStepUriFromIndex(goToStepIndex))
        const pageUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${this.urlParams.toString()}`
        window.history.pushState({}, '', pageUrl)
        trackPageview(pageUrl)

        this.showStepFromUrl()
      }

      prevNext(prop_value = 0) {
        const value = prop_value

        // If going forward, validate the current step before moving on
        if (value === 1) {
          return this.validate().then((valid) => {
            if (!valid) {
              return false;
            }

            this.goToPrevNextStep(value)
          })
        }

        return this.goToPrevNextStep(value)
      }

      validate() {
        const step = this.steps[this.currentStepIdx];
        return validateStep(step);
      }

      updateValuesFromPlace(autoCompleteInput, place) {

        let postalCodeTarget = document.getElementById(`${autoCompleteInput.dataset.postalCodeTarget}`);
        let cityTarget = document.getElementById(`${autoCompleteInput.dataset.cityTarget}`);
        let stateTarget = document.getElementById(`${autoCompleteInput.dataset.stateTarget}`);
        let streetNumberComponent = place.address_components.find((component) => component.types.includes('street_number'));
        let streetNameComponent = place.address_components.find((component) => component.types.includes('route'));
        let postalCodeComponent = place.address_components.find((component) => component.types.includes('postal_code'));
        let cityComponent = place.address_components.find((component) => component.types.includes('locality'));
        let stateComponent = place.address_components.find((component) => component.types.includes('administrative_area_level_1'));

        const isStreetAllowed = autoCompleteInput.dataset.autocompleteType === 'fullAddress';

        // Ensure we only save the place if it's a city (with zip) or a zipcode, unless full address is needed
        if (!isStreetAllowed && (!postalCodeComponent || (!cityComponent && !postalCodeComponent))) {
            console.warn('Google Places: Only cities with zip codes or standalone zip codes are allowed.');
            return; // Exit early if the place doesn't meet the criteria
        }

        this.saveValue(autoCompleteInput);

        if (postalCodeComponent) {
            postalCodeTarget.value = postalCodeComponent.long_name;
            this.saveValue(postalCodeTarget);
        }

        if (cityTarget && cityComponent) {
            cityTarget.value = cityComponent.long_name;
            this.saveValue(cityTarget);
        }

        if (stateTarget && stateComponent) {
            if (stateTarget.nodeName === 'SELECT') {
                const currentSelection = stateTarget.querySelector('[select]');
                if (currentSelection) {
                    currentSelection.removeAttribute('selected');
                }

                const newValue = stateTarget.querySelector(`[value="${stateComponent.short_name}"]`);
                if (newValue) {
                    newValue.setAttribute('selected', 'selected');
                }
            } else {
                stateTarget.value = stateComponent.short_name;
            }

            this.saveValue(stateTarget);
        }

        if (autoCompleteInput){
          // Only update the input if it's a city/zipcode, or if the input explicitly allows street addresses
          if (isStreetAllowed && streetNumberComponent && streetNameComponent) {
              autoCompleteInput.value = `${streetNumberComponent.long_name} ${streetNameComponent.long_name}`;
              this.saveValue(autoCompleteInput);
          } else if (cityComponent) {
              autoCompleteInput.value = `${cityComponent.long_name}`;
              this.saveValue(autoCompleteInput);
          } else if (postalCodeComponent) {
              autoCompleteInput.value = postalCodeComponent.long_name;
              this.saveValue(autoCompleteInput);
          }
        }
      }


      placesAutocompleteInputHandler(event) {
        const autoCompleteInput = this.steps[this.currentStepIdx].querySelector('.js-autocomplete-input')
        const placeIdTarget = document.getElementById(autoCompleteInput.dataset.placeIdTarget)
        if (placeIdTarget) {
          placeIdTarget.value = ''
          this.saveValue(placeIdTarget)
        }
      }

      setupPlacesAutocomplete(step) {

        const autocompleteOptions = JSON.parse(step.dataset.placesOptions || '{}')
        const autoCompleteInput = step.querySelector('.js-autocomplete-input')
        const placeIdTarget = document.getElementById(autoCompleteInput.dataset.placeIdTarget)

        if (!autoCompleteInput) {
          return;
        }

        // Reset the place id on input
        autoCompleteInput.removeEventListener('input', this.placesAutocompleteInputHandler)
        autoCompleteInput.addEventListener('input', this.placesAutocompleteInputHandler)

        const options = Object.assign({}, {
          // bounds: defaultBounds,
          componentRestrictions: { country: "us" },
          fields: ["address_components", "geometry", 'place_id'],
          strictBounds: false,
          types: ["(regions)"],
        }, autocompleteOptions);

        if (typeof google === 'undefined') {
          window.addEventListener('load', () => {
            this.initGooglePlaces(autoCompleteInput, placeIdTarget, options)
          })
        } else {
          this.initGooglePlaces(autoCompleteInput, placeIdTarget, options)
        }
      }

      initGooglePlaces(autoCompleteInput, placeIdTarget, options) {

        const autocomplete = new google.maps.places.Autocomplete(autoCompleteInput, options);

          autocomplete.addListener('place_changed', () => {
              const place = autocomplete.getPlace();

              console.log('Google Places:Place selected:', place);

              if (!place) {
                  console.warn('Google Places: place not found', place);
                  return;
              }

              let postalCodeComponent = place.address_components.find((component) => component.types.includes('postal_code'));

              if (!postalCodeComponent && place.geometry) {
                  console.log('Google Places: Postal code not found, attempting geocode...');

                  const geocoder = new google.maps.Geocoder();
                  geocoder.geocode({ location: place.geometry.location }, (results, status) => {
                      console.log('Google Places: Geocoding results:', results, 'Status:', status);

                      if (status !== 'OK' || !results || results.length === 0) {
                          console.warn('Google Places: Geocoder failed or returned no results.');
                          return;
                      }

                      const resultPlace = results[0];

                      postalCodeComponent = resultPlace.address_components.find((component) => component.types.includes('postal_code'));

                      if (postalCodeComponent) {
                          console.log('Google Places: Postal code found through geocoding:', postalCodeComponent.long_name);
                      } else {
                          console.warn('Google Places: Postal code still not found after geocoding.');
                          alert('there seems to be an issue with geo-coding your search, please try again with your zip code');
                      }

                      if (placeIdTarget) {
                          placeIdTarget.value = resultPlace.place_id;
                          console.log('Google Places: Place ID set from geocode:', placeIdTarget.value);
                      }

                      this.updateValuesFromPlace(autoCompleteInput, resultPlace);
                  });

              } else if (postalCodeComponent) {
                  console.log('Google Places: Postal code found:', postalCodeComponent.long_name);

                  if (placeIdTarget) {
                      placeIdTarget.value = place.place_id;
                      console.log('Place ID set:', placeIdTarget.value);
                  }

                  this.updateValuesFromPlace(autoCompleteInput, place);
              } else {
                  console.warn('Google Places: Postal code not found and no geometry available for geocoding.');
              }
          });
      }


      clearErrors(e) {
        if (e.target.closest('.js-input-group').classList.contains('has-error')) {
          e.target.closest('.js-input-group').classList.remove('has-error')
        }
      }

      updateProgressBar(prop_stepIdx = 0) {
        const percentage = prop_stepIdx / this.steps.length

        this.progressBar.style.transform = `scaleX(${percentage === 0 ? '0.01' : percentage})`
      }

      handlePopstate() {
        // Update the url params and resume
        this.urlParams = new URLSearchParams(window.location.search)
        trackPageview(`${window.location.pathname}${window.location.search}`)

        // Handle if the back button is selected from the quote screen
        if (this.urlParams.get('step') != 'quote') {
          setFormActive()
        }

        // Just incase the user clicks back while
        // Adjust Details is open
        modals.closeAll()

        // update step fields incase they were updated
        // from adjust details
        this.store()

        this.showStepFromUrl()
      }

      addEvents() {
        for (let formControl of this.formControls) {
          formControl.addEventListener('keyup', this.clearErrors.bind(this))
          formControl.addEventListener('change', this.clearErrors.bind(this))
        }

        this.btnPrev.addEventListener('click', this.prevNext.bind(this, -1))
        this.btnNext.addEventListener('click', this.prevNext.bind(this, 1))

        window.addEventListener('popstate', this.handlePopstate.bind(this))
      }
    }

    // ---

    window.addEventListener('DOMContentLoaded', () => {
      window.formWizardObjs = {}

      const formWizards = [...document.querySelectorAll('.js-form-wizard')]

      if (formWizards.length) {
        for (let formWizard of formWizards) {
          formWizardObjs[formWizard.id] = new FormWizard(formWizard)
        }
      }
    })

  }

  function trackPageview(url) {
    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({ event: 'GAVirtualPageview', virtualPageviewUrl: url })
    }
  }

  function getRequestData(type) {

    let listData = JSON.parse(localStorage.getItem('js-form-control'))
    let fullAddress = `${listData.address || ''} ${listData.addressLineTwo || ''}`.trim();

    if (type == "quote_looking_to_do_purchase") {
      return (Object.assign(listData || '{}'), {
        "lookingToDo": type,
        "howCredit": listData.howCredit,
        "underContract": listData.underContract,
        "propertyZip": listData.propertyZip,
        "hasServedMilitary": listData.hasServedMilitary,
        "firstName": listData.firstName,
        "lastName": listData.lastName,
        "email": listData.email,
        "phone": listData.phone,
        "website": "",
        "leadSource": "Google+/+Internet+Search",
        "purchasePrice": listData.purchasePrice,
        "amountDown": listData.amountDown,
        "percentDown": listData.percentDown,
        "typeProperty": listData.typeProperty,
        "wantsHomeConnect": listData.wantsHomeConnect,
        "address": fullAddress,
        "city": listData.city,
        "state": listData.stateFinancing,
        "stateFinancing": listData.stateFinancing,
        "zip": listData.propertyZip,
        "hasOptedIn": listData.hasOptedIn,
      });
    }

    else if (type == "heloc") {
      return (Object.assign(listData || '{}'), {
        "typeProperty": listData.typeProperty,
        "lookingToDo": type,
        "howCredit": listData.howCredit,
        "propertyValue": listData.propertyValue,
        "currentMortgage": listData.currentMortgage,
        "requestedLineAmount": listData.requestedLineAmount,
        "stateFinancing": listData.stateFinancing,
        "state": listData.stateFinancing,
        "propertyZip": listData.refinancePropertyZip,
        "firstName": listData.firstName,
        "lastName": listData.lastName,
        "email": listData.email,
        "phone": listData.phone,
        "website": "",
        "leadSource": "Google+/+Internet+Search",
        "address": fullAddress,
        "city": listData.city,
        "zip": listData.refinancePropertyZip,
        "hasOptedIn": listData.hasOptedIn,
      });
    }

    return (Object.assign(listData || '{}'), {
      "typeProperty": listData.typeProperty,
      "lookingToDo": type,
      "howCredit": listData.howCredit,
      "propertyValue": listData.propertyValue,
      "currentMortgage": listData.currentMortgage,
      "stateFinancing": listData.stateFinancing,
      "state": listData.stateFinancing,
      "propertyZip": listData.refinancePropertyZip,
      "hasServedMilitary": listData.hasServedMilitary,
      "firstName": listData.firstName,
      "lastName": listData.lastName,
      "email": listData.email,
      "phone": listData.phone,
      "additionalCash": listData['cash-out'] == '1' && listData.additionalCash || '0',
      "website": "",
      "leadSource": "Google+/+Internet+Search",
      "address": fullAddress,
      "city": listData.city,
      "zip": listData.refinancePropertyZip,
      "hasOptedIn": listData.hasOptedIn,
    });
  }

  function validateStep(step) {
    return new Promise((resolve, reject) => {
      // Get names of all form inputs

      const nonceField = document.querySelector('input[name=wp_rest_nonce]');

      // Reset the error state on each validation
      [...step.querySelectorAll('.has-error')].forEach((errors) => {
        errors.classList.remove('has-error')
      })

      const currentStepRequiredElements = [...step.querySelectorAll('[required]')]
      let valid = true;

      let verifyEmailField = null;

      // Get values of valid field
      for (var i = 0; i < currentStepRequiredElements.length; i++) {

        //trim whitespace
        currentStepRequiredElements[i].value = currentStepRequiredElements[i].value.trim();
        // Validate

        if (currentStepRequiredElements[i].name === 'email' && !emailRegex.test(currentStepRequiredElements[i].value)) {
          currentStepRequiredElements[i].closest('.form-group').classList.add('has-error')
          valid = false
        } else if (currentStepRequiredElements[i].name === 'email' && emailRegex.test(currentStepRequiredElements[i].value)) {
          // Email passed the initial regex test. Do additional backend validation
          verifyEmailField = currentStepRequiredElements[i]
        } else if(currentStepRequiredElements[i].name === 'phone' &&
          currentStepRequiredElements[i].value.replace(phoneRegex, '').length < 10) {
          currentStepRequiredElements[i].closest('.form-group').classList.add('has-error')
          valid = false
        } else if(currentStepRequiredElements[i].value === null) {
          currentStepRequiredElements[i].closest('.form-group').classList.add('has-error')
          valid = false
        } else if(currentStepRequiredElements[i].value === '$0.00') {
          currentStepRequiredElements[i].closest('.form-group').classList.add('has-error')
          valid = false
        }else if(currentStepRequiredElements[i].value === ''){
          currentStepRequiredElements[i].closest('.form-group').classList.add('has-error')
          valid = false
        }
      }

      // Allows switching be able to do async validation if need.
      let requiresBackendValidation = false

      if (verifyEmailField) {
        requiresBackendValidation = true

        $.ajax({
          url: '/wp-json/lp/v1/verify/email',
          method: 'POST',
          data: {
            'email': verifyEmailField.value,
            'wp_rest_nonce': nonceField.value,
          }
        }).then((response) => {
          if (response && !response.data.verified) {
            valid = false
            verifyEmailField.closest('.form-group').classList.add('has-error')
            return resolve(valid)
          }

          resolve(valid)
        })

        return;
      }



      if (!requiresBackendValidation) {
        resolve(valid)
      }
    })
  }

  function handleAdjustmentIncrementClick(event) {
    const button = event.target
    const targetFieldId = button.dataset.target
    const targetField = document.getElementById(targetFieldId)

    if (!targetField) {
      return;
    }

    let value = parseInt(targetField.value.replace(cleanNumberRegex, ''), 10);
    value = isNaN(value) ? 0 : value;

    if (button.classList.contains('plus')) {
      value += 10000;
    } else if (button.classList.contains('minus') && value > 999) {
      value -= 10000;
    }

    targetField.value = formatCalculatorValue(value, targetField.dataset.format)
    targetField.dispatchEvent(new Event('input'))
  }

  function handleAdjustmentFieldInput(event) {

    const element = event.target
    var values = JSON.parse(localStorage.getItem('js-form-control') || '{}');

    // // Update the connected element as you slide
    // if (element.dataset.target) {
    //   let targetElement = document.getElementById(element.dataset.target)
    //   if (targetElement) {
    //     targetElement.value = formatCalculatorValue(element.value, targetElement.dataset.format)
    //   }
    // }

    // Additional cash was updated so set the cash out option to true
    if (element.name == 'additionalCash') {
      values['cash-out'] = '1';
    }

    if (element.type === 'checkbox') {
      values[element.name] = this.getCheckboxValue(element)
    } else if (!element.classList.contains('js-money')) {
      values[element.name] = element.value;
    } else {
      values[element.name] = element.value.replace(cleanNumberRegex, '');
    }

    localStorage.setItem('js-form-control', JSON.stringify(values));
  }

  function handleAdjustmentFieldFocus(event) {
    let format = event.target.dataset.format
    if (!format) {
      return;
    }
    event.target.value = event.target.value.replace(cleanNumberRegex, '')
  }

  function handleAdjustmentFieldBlur(event) {
    let format = event.target.dataset.format
    if (!format) {
      return;
    }

    let formattedValue = formatCalculatorValue(event.target.value, format)
    event.target.value = formattedValue
  }

  function handleResubmitClick(event) {
    const step = event.target.closest('.js-adjust-details')

    validateStep(step).then((valid) => {

      if (!valid) {
        return;
      }

      var button = document.querySelector('.accordion-btn')
      var accordion = document.querySelector('.accordion')

      if (button.classList.contains('open')){
        button.classList.remove('open')
        accordion.classList.remove('open')
      }

      var whichForm = document.querySelector('.free-rate-quote')
      const postData = getRequestData(whichForm.name)

      ajaxCall(postData, { fromAdjustment: true, urlParams: new URLSearchParams(window.location.search) });
    })
  }

  function adjustDetails() {

    var values = JSON.parse(localStorage.getItem('js-form-control') || '{}');

    var adjustForms = document.querySelectorAll('.form-adjustments')

    adjustForms.forEach((adjustForm) => {

      var inputs = adjustForm.querySelectorAll('input[type="text"]');
      inputs.forEach(function(input) {

        input.removeEventListener('blur', handleAdjustmentFieldBlur)
        input.addEventListener('blur', handleAdjustmentFieldBlur);

        // On focus, switch to using just numeric value
        input.removeEventListener('focus', handleAdjustmentFieldFocus)
        input.addEventListener('focus', handleAdjustmentFieldFocus)
      });

      var elements = adjustForm.querySelectorAll('.js-form-control');

      elements.forEach((element) => {

        if (element.type != 'checkbox') {

          if (element.name == 'additionalCash' && values['cash-out'] != '1') {
            values['additionalCash'] = 0
          }

          element.value = formatCalculatorValue(values[element.name] || '', element.dataset.format)
        }

        if (element.type === 'checkbox') {
          // attempt to update any conditional steps if there are any for this checkbox
          element.checked = values[element.name] && values[element.name].length
          this.updateConditionalFromCheckboxState(element)
        }

        element.removeEventListener('input', handleAdjustmentFieldInput)
        element.addEventListener('input', handleAdjustmentFieldInput)
      });

      var increments = adjustForm.querySelectorAll('.increment--wrap')

      increments.forEach((increment) => {
        var buttons = increment.querySelectorAll('.plus-minus--button');

        buttons.forEach((button) => {
          button.removeEventListener('click', handleAdjustmentIncrementClick)
          button.addEventListener('click', handleAdjustmentIncrementClick)
        })
      })

      var resubmits =  adjustForm.querySelectorAll('.js-resubmit');

      resubmits.forEach(resubmit => {
        resubmit.removeEventListener('click', handleResubmitClick)
        resubmit.addEventListener('click', handleResubmitClick)
      })
    });

  }

  function renderQuote(quoteElement, quoteEntry) {

    const rateFormat = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 3,
    });

    const quoteDetail = quoteEntry.quote.quote_detail;

    let costProfitDetail = quoteDetail.costs_and_profit.profit_detail;
    let amountFromBorrower = parseFloat(costProfitDetail.amt_from_borrower['@attributes'].profit_dollar) || 0;

    let fees = [];
    let feesTotal = 0;
    let quoteDetailFeesList = quoteDetail.fees && quoteDetail.fees.fee_list || {}

    Object.keys(quoteDetailFeesList).forEach((feeListKey) => {
      const fee = quoteDetailFeesList[feeListKey]
      fees.push(fee)
      feesTotal += parseFloat(fee['@attributes'].feeamount) || 0
    })

    let borrowerRebate = parseFloat(quoteDetail.fees.borrowerRebate) || 0;

    console.log('fees', amountFromBorrower, feesTotal)
    console.log('borrowerRebateFee', borrowerRebate)
    console.log('')

    // // if amount from borrower + fees total - borrowerRebate > 0 = lender fees
    // // else lender credits
    let totalFeeOrRebate = amountFromBorrower + feesTotal + borrowerRebate;
    feesTotal = totalFeeOrRebate > 0 ? totalFeeOrRebate : 0;
    borrowerRebate = totalFeeOrRebate < 0 ? Math.abs(totalFeeOrRebate) : 0;

    quoteElement.querySelector('.js-rate').innerHTML = `${rateFormat.format(quoteDetail["@attributes"].rate)}%`;
    quoteElement.querySelector('.js-apr').innerHTML = formatCalculatorValue(quoteDetail["@attributes"].apr, 'percentage');
    quoteElement.querySelector('.js-fee-amount').innerHTML = formatCalculatorValue(feesTotal, 'currency');
    quoteElement.querySelector('.js-payment').innerHTML = formatCalculatorValue(quoteDetail["@attributes"].piti, 'currency');
    quoteElement.querySelector('.js-borrower-rate').innerHTML = formatCalculatorValue(borrowerRebate, 'currency');
  }

  function renderQuoteResults(quoteData) {

    var allTabs = [...document.querySelectorAll('[data-years]')]

    let errorNotice = document.querySelector('.rate-error-notice')
    errorNotice.classList.add('u-display-none')

    var fifteenTab = document.querySelector('[data-years="fifteen-years"]')
    var fifteenRates = document.getElementById(fifteenTab.getAttribute('aria-controls')).querySelectorAll('.js-rates')

    var twentyTab = document.querySelector('[data-years="twenty-years"]')
    var twentyRates = document.getElementById(twentyTab.getAttribute('aria-controls')).querySelectorAll('.js-rates')

    var thirtyTab = document.querySelector('[data-years="thirty-years"]')
    var thirtyRates = document.getElementById(thirtyTab.getAttribute('aria-controls')).querySelectorAll('.js-rates')

    // Reset hidden items for rendering.
    // These will be hidden later if the data requires
    allTabs.forEach((tab) => {
      tab.classList.remove('u-display-none')
      const tabPanel = document.getElementById(tab.getAttribute('aria-controls'))
      if (tabPanel) {
        tabPanel.classList.remove('u-diplay-none')
      }
    })

    const quoteTypeKey = quoteData.lead.hasServedMilitary ? 'VA' : 'CONV';

    document.querySelector('.rate--form').classList.add('js-active')
    document.querySelector('.js-zip').innerHTML = quoteData.lead.propertyZip;

    console.log('data', quoteData)

    if (quoteData.existingQuote) {
      document.querySelector('.js-adjust-detail-btn').classList.add('u-display-none')
    } else {
      document.querySelector('.js-adjust-detail-btn').classList.remove('u-display-none')
    }

    const quotes = quoteData.quote_details && quoteData.quote_details.quotes || {};

    let fifteenArray = quotes["15 year fixed"] &&  quotes["15 year fixed"][quoteTypeKey] && quotes["15 year fixed"][quoteTypeKey].results
    if(fifteenArray) {
      for (let i = 0; i < fifteenArray.length; i++) {
        renderQuote(fifteenRates[i], fifteenArray[i])
      }
    } else {
      // Hide the 15 year product if no quote data came back
      fifteenTab.classList.add('u-display-none');
    }

    let twentyArray = quotes["20 year fixed"] &&  quotes["20 year fixed"][quoteTypeKey] && quotes["20 year fixed"][quoteTypeKey].results
    if(twentyArray) {
      for (let i = 0; i < twentyArray.length; i++) {
        renderQuote(twentyRates[i], twentyArray[i])
      }
    } else {
      twentyTab.classList.add('u-display-none');
    }

    let thirtyArray = quotes["30 year fixed"] &&  quotes["30 year fixed"][quoteTypeKey] && quotes["30 year fixed"][quoteTypeKey].results
    if(thirtyArray) {
      for (let i = 0; i < thirtyArray.length; i++) {
        renderQuote(thirtyRates[i], thirtyArray[i])
      }
    } else {
      thirtyTab.classList.add('u-display-none');
    }

    let hiddenTabs = allTabs.filter((tab) => tab.classList.contains('u-display-none'))

    // Hide any tab panels related to hidden tabs
    hiddenTabs.forEach((hiddenTab) => {
      const tabPanel = document.getElementById(hiddenTab.getAttribute('aria-controls'))
      if (tabPanel) {
        tabPanel.classList.add('u-display-none')
        tabPanel.classList.remove('u-display-block')
      }
    })

    // Display the error notice if all the tabs are now hidden
    if (hiddenTabs.length == allTabs.length) {
      errorNotice.classList.remove('u-display-none')
    } else {
      // Trigger a click event on the first visible tab
      const firstVisibleTab = allTabs.find((tab) => !tab.classList.contains('u-display-none'))
      if (firstVisibleTab) {
        firstVisibleTab.dispatchEvent(new Event('click'))
      }
    }

    setQuoteActive()
  }

  function renderHELOCResults() {
    document.querySelector('.rate--form').classList.add('js-active')


    setQuoteActive()
  }

  function showQuote(postData, options) {

    options = options || {}

    if (typeof postData !== 'undefined') {
      return ajaxCall(postData, options)
    }

    const quoteId = options.urlParams.get('quote')
    const quoteDataElem = document.getElementById('quote-data')

    if (quoteDataElem.dataset.quoteId == quoteId) {
      try {
        const quoteData = JSON.parse(quoteDataElem.textContent.trim())

        if (quoteData.data) {

          console.log('trying to load quote data');

          setLoadingActive()
          setQuoteActive()
          if (this?.whichForm?.name === "heloc") {
            renderHELOCResults();
          } else {
            renderQuoteResults(quoteData.data);
          }
        }

      } catch(e) {
        console.error(e)
      }
    }
  }

  function setFormActive() {
    document.querySelector('.loading').classList.remove('js-active');
    document.querySelector('.banner').classList.remove('reverse-dark');
    document.querySelector('.multiform-wrap').classList.remove('u-display-none')
    document.querySelector('.rate--form').classList.remove('js-active')
  }

  function setLoadingActive() {
    document.querySelector('.loading').classList.add('js-active');
    document.querySelector('.banner').classList.add('reverse-dark');
    document.querySelector('.multiform-wrap').classList.add('u-display-none')
    document.querySelector('.rate--form').classList.remove('js-active')
  }

  function setQuoteActive() {
    document.querySelector('.loading').classList.remove('js-active');
  }

  function ajaxCall(postData, options) {

    options = options || {}

    const existingUniqueId = sessionStorage.getItem('leadUniqueId')
    if (existingUniqueId) {
      postData.uniqueId = existingUniqueId
    }

    // Abourt an longer running XHR requests
    if (currentXhr && currentXhr.length) {
      currentXhr.forEach((xhr) => xhr.abort())
      currentXhr = [];
    }

    // Append UTM parameters to formData
    const utmParams = UTMTracking.getUTMParamsFromLocalStorage();
    console.log('UTM Params:', utmParams);
    Object.assign(postData, { utm: utmParams });

    const leadCreateRequest = $.ajax({
      url: "/wp-json/lp/v1/lead/create",
      type: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
      },
      contentType: "application/x-www-form-urlencoded",
      data: postData,
      beforeSend: function () {
        setLoadingActive()
        modals.closeAll()
      },
    })
    .done((response) => {

      const leadData = response.data.data

      // Update the current state now that there's a specific quote to reference
      if (options.urlParams) {
        options.urlParams.set('quote', leadData.uniqueId)
        sessionStorage.setItem('leadUniqueId', leadData.uniqueId)
        window.history.replaceState({}, '', `${window.location.pathname}?${options.urlParams.toString()}`)
        trackPageview(`/rate-quote/${leadData.uniqueId}`)
      }

      // Reset this incase there wasn't one set from session storage
      postData.uniqueId = leadData.uniqueId

      const crmRequest = $.ajax({
        url: "/wp-json/lp/v1/lead/crm",
        type: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=utf-8",
        },
        contentType: "application/x-www-form-urlencoded",
        data: postData,
      })

      currentXhr.push(crmRequest)

      if(leadData.lookingToDo != 'heloc'){
      const quoteRequest = $.ajax({
        url: "/wp-json/lp/v1/leads/quotes/" + leadData.uniqueId,
        type: "GET",
      })
      .done(function (response, textStatus, jqXHR) {
      })

      currentXhr.push(quoteRequest)

      $.when(crmRequest, quoteRequest).then((crm, quote) => {

        if (!options.fromAdjustment) {
          adjustDetails();
        }

        renderQuoteResults(quote[0].data)
      })
    } else {
      renderHELOCResults()
    }
    })


    currentXhr.push(leadCreateRequest)

    return false;
  }


  function tabs() {
    const tabs = document.querySelectorAll('[data-years]')
    const tabInfos = document.querySelectorAll('[data-info]')

    tabs.forEach(tab => {
      tab.addEventListener('click', (event) => {

        document.querySelector('.tab-active').classList.remove('tab-active')
        tab.classList.add('tab-active')

        const target = document.getElementById(tab.getAttribute('aria-controls'));

        tabInfos.forEach(tabInfo => {
          tabInfo.classList.remove('active')
        })
        target.classList.add('active');
      })
    })
  }

  function init() {
    if (forms) {
      initMultiStepForm();

      tabs();
    }
  }

  return {
    init: init
  };


  /* eslint-enable no-unused-vars */

})()
